import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { FormService } from '../services/form/form.service';

@Pipe({
    name: 'formErrors',
    standalone: true,

    // WARN: Use with caution!
    // Use `pure: false` if the pipe should be called on value changed.
    pure: false,
})
export class FormErrorsPipe implements PipeTransform {
    public constructor(private readonly formService: FormService) {}

    public transform(control: AbstractControl, errorKeyPrefix: string = ''): { [controlPath: string]: string[] } {
        if (!control) {
            return null;
        }

        return this.formService.getFormErrorsWithMessages(control, errorKeyPrefix);
    }
}
